"use strict";

exports.__esModule = true;
exports.isSameSecond = isSameSecond;
exports.parseFormat = parseFormat;
exports.parseTimeData = parseTimeData;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
function padZero(num, targetLength) {
  if (targetLength === void 0) {
    targetLength = 2;
  }
  var str = num + '';
  while (str.length < targetLength) {
    str = '0' + str;
  }
  return str.substr(0, targetLength);
}
var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
function parseTimeData(format, time, options) {
  if (options === void 0) {
    options = {
      preserveExceededHours: false,
      preserveExceededDays: false
    };
  }
  var days = '';
  var hours = '';
  var minutes = '';
  var seconds = '';
  var milliseconds = '';

  // 如果传入DD:HH:mm:ss，但是天数超过两位数，默认是截断的。
  // preserve-exceeded-days为true的时候不截断。
  if (format.includes('DD')) {
    var dayFloor = Math.floor(time / DAY);
    var dayFloorString = dayFloor.toString();
    var DLength = format.replace(/[^D]/g, '').length;
    days = options.preserveExceededDays ? padZero(dayFloorString, Math.max(DLength, dayFloorString.length)) : padZero(dayFloorString, DLength);
    time = time % DAY;
  }

  // 如果传入HH:mm:ss，但是小时数超过两位数，默认是截断的。
  // preserve-exceeded-hours为true的时候不截断。
  if (format.includes('HH')) {
    var hourFloor = Math.floor(time / HOUR);
    var hourFloorString = hourFloor.toString();
    var HLength = format.replace(/[^H]/g, '').length;
    hours = options.preserveExceededHours ? padZero(hourFloorString, Math.max(HLength, hourFloorString.length)) : padZero(hourFloorString, HLength);
    time = time % HOUR;
  }
  if (format.includes('mm')) {
    minutes = padZero(Math.floor(time / MINUTE));
    time = time % MINUTE;
  }
  if (format.includes('ss')) {
    seconds = padZero(Math.floor(time / SECOND));
    time = time % SECOND;
  }
  if (format.includes('SSS')) {
    milliseconds = padZero(time, 3);
  } else if (format.includes('SS')) {
    milliseconds = padZero(time, 2);
  } else if (format.includes('S')) {
    milliseconds = padZero(time, 1);
  }
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    milliseconds: milliseconds,
    daysArr: days.split(''),
    hoursArr: hours.split(''),
    minutesArr: minutes.split(''),
    secondsArr: seconds.split(''),
    millisecondsArr: milliseconds.split('')
  };
}
function parseFormat(format, timeData) {
  var days = timeData.days,
    hours = timeData.hours,
    minutes = timeData.minutes,
    seconds = timeData.seconds,
    milliseconds = timeData.milliseconds;
  format = format.replace(/D+/, days);
  format = format.replace(/H+/, hours);
  format = format.replace('mm', minutes);
  format = format.replace('ss', seconds);
  if (milliseconds) {
    format = format.replace('SSS', milliseconds);
    format = format.replace('SS', milliseconds);
    format = format.replace('S', milliseconds);
  }
  return format;
}
function isSameSecond(time1, time2) {
  return Math.floor(time1 / 1000) === Math.floor(time2 / 1000);
}